document.addEventListener('DOMContentLoaded', () => {
  waitForSearchSlider();
});

function initSearchSlider() {

  const sliderContainer = document.querySelector(
    '.slider__container.search__product-results'
  );
  const slides = document.querySelectorAll('.predictive-search__list-item');

  const dotsContainer = document.querySelector('.slider__dots__search_results');

  if (sliderContainer && slides.length && dotsContainer) {

    const dots = dotsContainer.querySelectorAll('.dot');

    // Dot click event to scroll to the specific slide
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        scrollToSlide(index);
        updateActiveDot(index);
      });
    });

    // Scroll event to update the active dot based on the slide in view
    sliderContainer.addEventListener('scroll', () => {
      const currentIndex = getCurrentSlideIndex();
      updateActiveDot(currentIndex);
    });

    function scrollToSlide(index) {
      const slideWidth = slides[0].offsetWidth;
      const targetPosition = slideWidth * index;
      sliderContainer.scrollTo({ left: targetPosition, behavior: 'smooth' });
    }

    function updateActiveDot(index) {
      dots.forEach((dot) => dot.classList.remove('active'));
      if (dots[index]) {
        dots[index].classList.add('active');
      }
    }

    function getCurrentSlideIndex() {
      const slideWidth = slides[0].offsetWidth;
      const currentIndex = Math.round(sliderContainer.scrollLeft / slideWidth);
      return currentIndex;
    }

    // Initialize by setting the first dot as active
    updateActiveDot(0);
  }
}

function waitForSearchSlider() {
  const sliderContainer = document.querySelector(
    '.slider__container.search__product-results'
  );

  if (sliderContainer) {
    initSearchSlider(); // Call the initialization function
  } else {
    // Retry with requestAnimationFrame to wait until the element is available
    requestAnimationFrame(waitForSearchSlider);
  }
}
